import { format } from 'date-fns';
import he from 'he';
import fp from 'lodash/fp';
import React, { Component } from 'react';
import { connect } from 'react-redux';

/**
 * Application dashboard view for authenticated User.
 */
class Info extends Component {

  renderIndustry(userIndustryRole) {
    const industryRole = fp.find((role) => role.id === userIndustryRole.industryRoleId)(this.props.industry.industryRoles);
    const industry = fp.find((industry) => industryRole && industryRole.industryId === industry.id)(this.props.industry.industries);
    if (industry) {
      return <span>{industry.name}</span>;
    }
  }

  renderIndustryRole(userIndustryRole) {
    const industryRole = fp.find((role) => role.id === userIndustryRole.industryRoleId)(this.props.industry.industryRoles);
    if (industryRole) {
      return <span>{industryRole.name}</span>;
    }
  }

  renderAfsLicences() {
    const userAfsLicences = this.props.user.currentUserAfsLicences;

    if (userAfsLicences.length === 0) {
      return <div>N/A</div>
    }
    else {
      return fp.map((afsLicence) =>
        <div key={afsLicence.id}>
          You are associated with AFSL number: {afsLicence.afsLicenceNumber}
        </div>)(userAfsLicences);
    }
  }

  renderBusinessAfsLicences() {
    const businessAfsLicences = this.props.user.currentUserAfsLicences;
    if (businessAfsLicences.length === 0) {
      return <div>N/A</div>;
    }
    else {
      return fp.map((afsLicence) => {
        const business = fp.find((business) => business.id === afsLicence.businessId)(this.props.user.currentUserBusinesses);
        if (business) {
          return (
            <div key={afsLicence.id}>
              Your business {he.decode(business.name)} has AFSL number: {afsLicence.afsLicenceNumber}
            </div>
          );
        }
        else {
          return null;
        }
      })(businessAfsLicences);
    }
  }

  renderCpdCategorys() {
    if (this.props.user.cpdCategoryProgress.cpdCategorys.length === 0) {
      return <div>N/A</div>
    }
    else {
      return (
        <ul>
          {
            fp.map((userCpdCategory) => {
              const cpdCategory = fp.find((cpdCategory) => cpdCategory.id === userCpdCategory.cpdCategoryId)(this.props.industry.cpdCategorys);
              const name = cpdCategory ? cpdCategory.name : userCpdCategory.cpdCategoryId;
              return <li key={userCpdCategory.cpdCategoryId}>{he.decode(name)}: {userCpdCategory.primaryStat.validCpd} CPD hour(s)</li>
            })(this.props.user.cpdCategoryProgress.cpdCategorys)
          }
        </ul>
      );
    }
  }

  render() {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        User Details <br />
        {
          this.props.user.currentUser ?
            <div>
              <br />
              User Industry Roles: <br />
              {
                fp.map((role) =>
                  <span key={role.id}>
                    <span>
                      {this.renderIndustryRole(role)}
                    </span>
                    &nbsp;
                    (Under {this.renderIndustry(role)})
                  </span>
                )(this.props.user.currentUserIndustryRoles)
              }
              <br /><br />

              User Account Roles:
              {
                fp.map((roleAssignment) => {
                  const business = roleAssignment.businessId ?
                    fp.find((business) => business.id === roleAssignment.businessId)(this.props.user.currentUserBusinesses) :
                    null;

                  const publisher = roleAssignment.publisherId ?
                    fp.find((publisher) => publisher.id === roleAssignment.publisherId)(this.props.user.currentUserPublishers) :
                    null;

                  return (
                    <div key={roleAssignment.id}>
                      <span>{roleAssignment.role} {business ? `in ${business.name}` : publisher ? `for ${publisher.name}` : 'as Individual'}</span>
                    </div>
                  )
                })(this.props.user.currentUser.roleAssignments)
              }

              <br /><br />

              User AFSL associations:
              {
                this.renderAfsLicences()
              }

              <br /><br />

              Business AFSL associations:
              {
                this.renderBusinessAfsLicences()
              }

              <br /><br />

              User CPD Categories:
              {
                this.renderCpdCategorys()
              }

              <br /><br />

              {`Email Verified: ${this.props.user.currentUser.emailVerified}`} (log out and back in again to update)<br />
              {`User Status: ${this.props.user.currentUser.activated ? 'Activated' : 'Inactive'}`}
            </div> : ''
        }
        {
          this.props.user.currentSubscription && this.props.user.currentSubscription.id ?
            <div>
              <br />
              {`Subscription Status: ${this.props.user.currentSubscription.status}`} | {this.props.user.currentSubscription.isPaused ? 'Paused' : 'Not Paused'}<br />
              {`Subscription Start Date: ${format(this.props.user.currentSubscription.startDate, 'YYYY-MM-DD')}`}<br />
              {`Subscription End Date: ${format(this.props.user.currentSubscription.endDate, 'YYYY-MM-DD')}`}<br />
            </div> : 'No Subscription for this User.'
        }
        <br /><br />
        {
          this.props.user.businessInvitations && this.props.user.businessInvitations.length > 0 ?
            <div>
              Sent team member invitations:
              {
                fp.map((inv) =>
                  <div key={inv.id}>
                    <div>Email: {inv.email} | First Name: {inv.firstName} | Last Name: {inv.lastName} | Status: {inv.status}</div>
                  </div>)(this.props.user.businessInvitations)
              }
            </div> : ''
        }
        <br /><br />
        {
          this.props.user.businessTeamMembers && this.props.user.businessTeamMembers.length > 0 ?
            <div>
              Business team members:
              {
                fp.map((member) =>
                  <div key={member.user.id}>
                    <div>Email: {member.user.email} | First Name: {member.user.firstName} | Last Name: {member.user.lastName} | Role: {member.role.role}</div>
                  </div>)(this.props.user.businessTeamMembers)
              }
            </div> : ''
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  industry: state.industry
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Info);



// WEBPACK FOOTER //
// ./src/containers/pages/info.js